export default __webpack_public_path__ + "static/media/referral__icon-5.ac30e6bd.svg";